import { yupResolver } from '@hookform/resolvers/yup';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from '@mui/material';
import Shield from 'assets/icons/shield_lock.svg';
import { formatCurrencyPtBr } from 'common/schema/currency-format';
import { morePersonalData } from 'common/schema/personal-data';
import { SubtitleMedium } from 'common/typography/SubtitleMedium';
import { TitleMedium } from 'common/typography/TitleMedium';
import { useForm } from 'react-hook-form';
import { FlexButton } from 'shared/components/Button/FlexButton';
import { CenterImage } from 'shared/components/Form/MultiStepForm/StepOne/style';
import { StepTwoProps } from 'shared/components/Form/MultiStepForm/StepTwo/types';
import Inputs from 'shared/components/Inputs/FormInput';
import { theme } from 'styles/global-themes';
import { BoxButton, IconWrapper, StepWrapper, TextBox } from './style';

export const StepTwo: React.FC<StepTwoProps> = ({ onGoToStep, goBack, loading , defaultValues}) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
    getValues,
    trigger
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(morePersonalData) as any,
    defaultValues: {
      ...defaultValues,
      monthlyIncome: defaultValues.monthlyIncome ? formatCurrencyPtBr(defaultValues.monthlyIncome / 100)   : ''
    }
  });

  const onSubmit = (values: any) => {
    onGoToStep({
      cpf: values.cpf.replace(/\D/g, ''),
      name: values.name,
      monthlyIncome: Number(values.monthlyIncome.replace(/\D/g, '')),
    });
  };

  return (
    <StepWrapper>
      <Box textAlign="center">
        <TextBox>
          <TitleMedium color={theme.palette.common.black}>Insira suas informações</TitleMedium>
          <SubtitleMedium color={'#5F5E60'}>Preencha seus dados pessoais.</SubtitleMedium>
        </TextBox>
      </Box>

      <Box display="flex" flexDirection="column" gap={2.5}>
        <Inputs control={control} name="cpf" label="CPF" placeholder="CPF" maskType="cpf" />

        <Inputs control={control} name="name" label="Nome completo" placeholder="Nome completo" />

        <Inputs
          control={control}
          name="monthlyIncome"
          label="Renda mensal"
          placeholder="Renda mensal"
          maskType="money"
        />

        <BoxButton>
          <FlexButton
            startIcon={ArrowBackIcon}
            $outline
            $backgroundColor={'transparent'}
            text="Voltar"
            handleClick={() => {
              const values = getValues();
              const formatedValues = {...values, monthlyIncome: Number(String(values.monthlyIncome).replace(/\D/g, ''))}
              goBack(1,formatedValues)
            } }
          />
          <FlexButton
            $backgroundColor={!isValid ? '#161C274D' : '#161C27'}
            text="Continuar"
            disabled={!isValid || loading}
            handleClick={handleSubmit(onSubmit)}
          />
        </BoxButton>

        <SubtitleMedium color={theme.palette.common.black}>
          <CenterImage>
            <IconWrapper src={Shield} alt="shield_lock" />
            Seus dados estão 100% protegidos e seguros
          </CenterImage>
        </SubtitleMedium>
      </Box>
    </StepWrapper>
  );
};
